import { render, staticRenderFns } from "./CreateSettlementPopup.vue?vue&type=template&id=396a4e25"
import script from "./CreateSettlementPopup.vue?vue&type=script&lang=ts"
export * from "./CreateSettlementPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports